import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import Helmet from 'react-helmet';
import Waypoint from 'react-waypoint';

import Container from '../Container';
import Footer from '../Footer';
import Layout from '../Layout';

import { getNavItem } from '../../lib/nav';

import styles from './index.module.scss';

const getBreadcrumbs = (...keys) => {
  const breadcrumbs = [];
  while (breadcrumbs.length < keys.length) {
    const navItem = getNavItem(...keys.slice(0, breadcrumbs.length + 1));
    breadcrumbs.push({
      key: navItem.key,
      text: navItem.text,
      uri: navItem.uri,
    });
  }
  return breadcrumbs;
};

const generateSubNav = (items, locale) => (
  <ul>
    {items.map(item => (
      <li key={item.uri}>
        {item.url ? (
          <a href={item.url}>{item.text[locale]}</a>
        ) : (
          <Link exact to={`/${locale}${item.uri}`}>
            {item.text[locale]}
          </Link>
        )}
        {!!item.items && generateSubNav(item.items, locale)}
      </li>
    ))}
  </ul>
);

/* eslint-disable react/prop-types */
export default class extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    locale: PropTypes.string,
    rootNavKey: PropTypes.arrayOf(PropTypes.string).isRequired,
    parentKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    pageKey: PropTypes.string.isRequired,
    image: PropTypes.string,
    showBreadcrumbs: PropTypes.bool,
    showNav: PropTypes.bool,
  };

  static defaultProps = {
    locale: 'en',
    image: null,
    showBreadcrumbs: true,
    showNav: true,
  };

  state = {
    fixedHeader: false,
  };

  render() {
    const {
      children,
      locale = 'en',
      rootNavKey = [],
      parentKeys = [],
      pageKey,
      image,
      showBreadcrumbs,
      showNav,
    } = this.props;
    const { fixedHeader } = this.state;

    const rootNavItem = getNavItem(...rootNavKey);
    const currentNavItem = pageKey ? getNavItem(...parentKeys, pageKey) : getNavItem(...parentKeys);
    const breadcrumbs = pageKey ? getBreadcrumbs(...parentKeys, pageKey) : getBreadcrumbs(...parentKeys);
    return (
      <Layout locale={locale} showHeader fixedHeader={fixedHeader}>
        <Helmet>
          <title>
            {currentNavItem.text[locale]} -{' '}
            {locale === 'en' ? 'Kingston International School Hong Kong' : '京斯敦國際學校(香港)'}
          </title>
        </Helmet>

        <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />

        <Waypoint
          topOffset="96px"
          onEnter={() => this.setState({ fixedHeader: false })}
          onLeave={() => this.setState({ fixedHeader: true })}
        />

        <Container className={styles.container}>
          <div className={styles.content}>
            {showBreadcrumbs && (
              <ul className={styles.breadcrumbs}>
                <li key="home">
                  <Link to="/">{locale === 'en' ? 'Home' : '主頁'}</Link>
                </li>
                {breadcrumbs.map(({ text, uri, key }) => (
                  <li key={key}>
                    <Link to={`/${locale}${uri}`}>{text[locale]}</Link>
                  </li>
                ))}
              </ul>
            )}
            {children}
          </div>

          {showNav && (
            <div className={styles.subNav}>
              <div className={styles.title}>{rootNavItem.text[locale]}</div>
              {generateSubNav(rootNavItem.items, locale)}
            </div>
          )}
        </Container>
        <Footer locale={locale} />
      </Layout>
    );
  }
}
